import { Injectable } from '@angular/core';
import { HttpClientHelper } from '../helpers/HttpClientHelper';
import { HelpersService } from '../helpers/helpers.service';
import { Observable } from 'rxjs';
import { TenantDetails } from '../models/tenantModel';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CorporateConfig } from '../corporate.config';
import { HttpParameter } from '../datatypes/misc';

@Injectable({
    providedIn: 'root'
})

export class TenantService {

    private readonly externalPageData: string;

    constructor(
        private httpClientHelper: HttpClientHelper,
        private helper: HelpersService,
        private http: HttpClient
    ) {
        this.externalPageData = this.helper.getPageContent(CorporateConfig.getCmsDomain + CorporateConfig.getCmsApi);
    }

    getTenantDetails(): Observable<TenantDetails> {
        return this.httpClientHelper.httpGet(new HttpParameter('TenantDetails'));
    }

    getCmsFooter(): Observable<any> {
        return this.http.get(this.externalPageData);
    }
}
